import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { AdminSystemComponent } from './admin-system.component';
import { AdminSystemSettingsActions } from './state/admin-system-settings-actions.service';
import { AdminSystemSettingsSelectors } from './state/admin-system-settings-selectors.service';
import { AdminSystemSettingsEffects } from './state/admin-system-settings.effect';
import { systemSettingsStateReducers } from './state/admin-system-settings.reducer';

@NgModule({
    declarations: [
        AdminSystemComponent
    ],
    imports: [
        CommonModule,

        RouterModule.forChild([
            { path: '', component: AdminSystemComponent }]),

        StoreModule.forFeature('systemSettingsForm', systemSettingsStateReducers),
        EffectsModule.forFeature([AdminSystemSettingsEffects]), // TODO: Move

        FormsModule,
        NgrxFormsModule // needs FormsModule

    ],
    providers: [
        AdminSystemSettingsActions,
        AdminSystemSettingsSelectors
    ]
})
export class AdminSystemModule {
}

// TODO: Make generic save button
